import { DocnboardConnector } from './connect';
import { powerSync } from './database';

export const setup = async () => {
  await powerSync.init();

  const connector = new DocnboardConnector();
  powerSync.connect(connector).catch(console.error);

  await powerSync.waitForFirstSync();
};
